import { Component, Input } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { CreativePerformance } from '../creative-detail-v2/creative-detail.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { CREATIVE_CONSTANTS } from '../../creative.constants';

@Component({
	selector: 'app-sem-creative-card',
	templateUrl: './sem-creative-card.component.html',
	styleUrls: ['./sem-creative-card.component.css']
})
export class SemCreativeCardComponent {
	@Input() key: string;
	@Input() sectiontitle: string;
	@Input() placeholderimage: string;
	@Input() downloadconfig: string;

	public showLoad = true;
	public hasData: boolean;
	public downloadConfiguration: DownloadConfig;
	public partnerColors: string[] = [];

	constructor(protected analyticsService: AnalyticsService) {}

	protected mapResponseDataToInterface(responseData) {
		const creativePerformances: CreativePerformance[] = [];
		let counter = 0;
		for (const response of responseData) {
			const creativeObj: any = {};
			let location = '';
			const siteLinksArr = [];
			const structuredSnippetExtnArr = [];
			const calloutsExtnArr = [];
			let structuredSnippetExtn = [];
			let calloutsExtn = [];
			const locationObj = !UtilityService.isUndefinedOrNull(response.location_extn)
				? JSON.parse(response.location_extn)[0]
				: {};
			creativeObj.ad_headline = UtilityService.isUndefinedOrNull(response.ad_headline)
				? ''
				: response.ad_headline == ''
				? ' '
				: response.ad_headline;
			creativeObj.clicks = parseFloat(response.clicks);
			creativeObj.clickthroughrate = parseFloat(response.clickthroughrate);
			creativeObj.impressions = parseFloat(response.impressions);
			creativeObj.avg_position = parseFloat(response.avg_position);
			try {
				creativeObj.url = typeof response.url == 'string' ? response.url : JSON.parse(response.url)[0];
			} catch (error) {
				creativeObj.url = response.url;
			}
			creativeObj.top_impression_share = parseFloat(response.top_impression_share);
			creativeObj.abs_top_impression_share = parseFloat(response.abs_top_impression_share);
			creativeObj.description = UtilityService.isUndefinedOrNull(response.description) ? '' : response.description;
			let temCreativeDesc = creativeObj.description.split('|');
			if (temCreativeDesc.length > 1) {
				creativeObj.description = temCreativeDesc;
			}
			creativeObj.topImpressionShare = parseFloat(response.top_impression_share).toFixed(2);
			creativeObj.absTopImpressionShare = parseFloat(response.abs_top_impression_share).toFixed(2);
			creativeObj.callExtension = response && response.call_extn ? JSON.parse(response.call_extn)[0][1] : '';
			if (this.partnerColors.length > 0) {
				creativeObj.htmlClass = this.getClassByIndex(counter);
			}
			const siteLinks = !UtilityService.isUndefinedOrNull(response.sitelink_extn)
				? JSON.parse(response.sitelink_extn)
				: [];
			let locationArr = [];
			for (let prop in locationObj) {
				if (parseInt(prop) > 1 && parseInt(prop) < 8) {
					locationArr.push(locationObj[prop]);
				}
			}
			location = locationArr.join(', ');
			creativeObj.location = location;
			if (response.structuredsnippet_extn) {
				structuredSnippetExtn = JSON.parse(response.structuredsnippet_extn);
				for (const item of structuredSnippetExtn) {
					structuredSnippetExtnArr.push({
						type: item['1'],
						value: !UtilityService.isUndefinedOrNull(item['2']) || item['2'] != '' ? item['2'].join(', ') : item['2']
					});
				}
			}
			if (response.callouts_extn) {
				calloutsExtn = JSON.parse(response.callouts_extn);
				for (const item of calloutsExtn) {
					calloutsExtnArr.push(item['1']);
				}
			}
			for (const item of siteLinks) {
				siteLinksArr.push({
					heading: item['1'] || '',
					description: (item['3'] || '') + ' ' + (item['4'] || ''),
					link: item['5'][0] || ''
				});
			}
			creativeObj.structuredSnippetExtn = structuredSnippetExtnArr;
			creativeObj.siteLinks = siteLinksArr;
			creativeObj.calloutsExtn = calloutsExtnArr.length > 0 ? calloutsExtnArr : [];
			creativePerformances.push(creativeObj);
			counter++;
		}
		return creativePerformances;
	}

	isTypeString(description) {
		return typeof description == 'string';
	}

	getClassByIndex(index) {
		const colorIndex = index % this.partnerColors.length;
		return this.partnerColors[colorIndex].trim() + '-color-bg';
	}
}
